import { render } from "./JuranewsDoc.vue?vue&type=template&id=09af24e0"
import script from "./JuranewsDoc.vue?vue&type=script&lang=ts"
export * from "./JuranewsDoc.vue?vue&type=script&lang=ts"
script.render = render

export default script